export default "__VITE_ASSET__2c837c35__"